export default {
  Admin: 100,
  Officer: 90,
  Committee: 80,
  Mentor: 70,
  Mentee: 65,
  Applicant: 60,
  User: 40,
};
